import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as EmpresaAPI from '../../../api/empresa';
import * as FinanceiroAPI from '../../../api/financeiro';
import * as PlantaoAPI from '../../../api/plantao';
import * as ProdutoAPI from '../../../api/produto';
import * as TabelaAPI from '../../../api/tabela';

import CRUDsAPI from '../../../api/CRUDs';

//helpers
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { resolveEmpresaTabela } from '../../../utils/funcoes';

const CreateOrEdit = () => {
    const { parametro } = useContext(Context);
    //escopo empresa
    const { empresaId, empresaIds } = getEmpresaScope();
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);
    const [dados, setDados] = useState({
        empresaId,
        ativo: true,
    });

    //tabelas filhas vinculadas
    const [pessoa, setPessoa] = useState({});

    const token = localStorage.getItem('token');

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    const [OptionsConta, setConta] = useState([]);
    const [OptionsForma, setForma] = useState([]);
    const [OptionsPrazo, setPrazo] = useState([]);
    const [OptionsEmpresa, setEmpresa] = useState([]);
    const [OptionsOperacao, setOptionsOperacao] = useState([]);
    const [OptionsPlantaoTipo, setOptionsPlantaoTipo] = useState([]);

    // serviços
    const [ncmImovel, setNcmImovel] = useState({});
    const [ncmServico, setNcmServico] = useState(dados?.ncmServico || {});

    const pathname = '/Parametro';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //enums e tabelas
    const [EnumTipo, setEnumTipo] = useState([]);
    const [optionsUnidade, setUnidade] = useState([]);

    //enums
    const tipoForma = async () => {
        const result = await TabelaAPI.enums('pagamentoFormas', 'tipo');
        setEnumTipo(result ? result : []);
    };
    const consultaForma = async (obj) => {
        const result = await FinanceiroAPI.buscaForma(obj);
        setForma(result);
    };
    const consultaPrazo = async (tipo, formaId, nivel, prazoId, empresaId = dados.empresaId, prazoMedio) => {
        const result = await FinanceiroAPI.prazo(tipo, formaId, nivel, prazoId, empresaId, prazoMedio);

        setPrazo(result);
    };
    const consultaConta = async (empresaIds, contaOrContaDestino) => {
        if (!empresaIds || empresaIds.length === 0) {
            console.warn('buscaConta: empresaIds inválido:', empresaIds);
            return;
        }

        try {
            const result = await FinanceiroAPI.buscaContaByEmpresaIds({ empresaIds });

            if (contaOrContaDestino === 'conta') {
                setConta(result);
            } else if (contaOrContaDestino === 'destino') {
                //setContaDestino(result);
            } else {
                console.warn('buscaConta: contaOrContaDestino inválido:', contaOrContaDestino);
            }
        } catch (error) {
            console.error('Erro ao buscar conta:', error);
        }
    };
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(empresaId);
        setEmpresa(result);
    };
    const consultaUnidade = async ({ empresaId, pesavel = false, entrada = false, saida = false, industria = false }) => {
        const result = await EmpresaAPI.unidade(empresaId, pesavel, entrada, saida, industria);
        setUnidade(result);
    };
    const consultaOperacao = async () => {
        const result = await ProdutoAPI.operacao();
        setOptionsOperacao(result);
    };
    const consultaPlantaoTipo = async (empresaIds) => {
        const result = await PlantaoAPI.obterPlantaoTipos(empresaIds);
        setOptionsPlantaoTipo(result || []);
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        tipoForma();
        consultaEmpresa();
        consultaForma({ tipo: tipo, empresaId: dados.empresaId });
        consultaPrazo(tipo, dados.formaId, null, null, dados.empresaId, null);
        consultaConta(empresaIds, 'conta');
        consultaUnidade({ empresaId: dados.empresaId });

        if (uuid && uuid !== 'null') {
            CRUDsAPI.parametro
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                    setPessoa(response.data?.pessoaPadrao || {});
                    setNcmImovel(response.data?.ncmImovel || {});
                    setNcmServico(response.data?.ncmServico || {});
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }
        consultaOperacao();
        consultaPlantaoTipo(empresaIds);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    async function managerDados(dados) {
        let urlNavigate = pathname;

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CRUDsAPI.parametro.editar(dados);
            } else {
                response = await CRUDsAPI.parametro.cadastrar(dados);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                //tabelas filhas
                pessoa={pessoa}
                setPessoa={setPessoa}
                handleSubmit={managerDados}
                btnText={btnText}
                OptionsForma={OptionsForma}
                OptionsPrazo={OptionsPrazo}
                OptionsEmpresa={OptionsEmpresa}
                optionsUnidade={optionsUnidade}
                OptionsConta={OptionsConta}
                OptionsPlantaoTipo={OptionsPlantaoTipo}
                OptionsOperacao={OptionsOperacao}
                //serviços
                ncmImovel={ncmImovel}
                setNcmImovel={setNcmImovel}
                ncmServico={ncmServico}
                setNcmServico={setNcmServico}
                //Enuns
                EnumTipo={EnumTipo}
                empresaId={empresaId}
                empresaTabelaId={empresaTabelaId}
                empresaIds={empresaIds}
                caminhoVoltar={pathname}
            />
        </section>
    );
};
export default CreateOrEdit;
